import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { DisclaimerTooltip } from '../cart/VendorListAndPriceDisc';

type Props = {
  priceTime: string;
};

export const AmazonPriceDisclaimer = ({ priceTime }: Props) => {
  const { t } = useTranslation();

  return (
    <DisclaimerTooltip
      title={
        <span className='flex flex-col gap-2'>
          <span className='font-semibold'>
            {t('deals.amazon.price_as_of', { time: priceTime })}
          </span>
          <span>{t('deals.amazon.price_disclaimer')}</span>
        </span>
      }
      describeChild
      placement='top'
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={5000}
    >
      <button
        type='button'
        aria-label={t('deals.amazon.price_details')}
        onClick={(e) => e.stopPropagation()}
        className='flex items-center fill-[#8b6914] hover:opacity-80'
      >
        <InfoOutlinedIcon className='transition-all' style={{ fontSize: 14, fill: 'inherit' }} />
      </button>
    </DisclaimerTooltip>
  );
};
